import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const DropZoneArea = styled.div`
	display: flex;
	background-color: white;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 32px;
	border-width: 0 1px 1px 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	border-radius: 0 0 3px 3px;
`;

export const DropZoneText = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const LeftAlignBox = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
`;

export const DescriptionText = styled.div`
	width: 150px;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;

	span {
		font-weight: 700;
		font-size: 16px;
		color: ${colors.grey7};
	}
`;

export const TitleMessage = styled.div`
	color: ${colors.grey8};
	padding-bottom: 32px;
	font-size: 19px;
	line-height: 27px;
	text-align: center;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const DropWrapper = styled.div`
	outline: none;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const IconWrapper = styled.div`
	margin-bottom: 32px;
`;

export const ButtonWrapper = styled.div`
	padding-top: 20px;
`;

export const ProgressText = styled.div`
	display: flex;
	width: 100%;
`;

export const RefreshStatusBlock = styled.div`
	margin: 0 auto;
	width: 150px;
	min-width: 150px;
	text-align: center;
`;
